import { DetailsWidget } from '@/components/DetailsWidget/DetailsWidget';
import { Box } from '@/components/Box/Box';
import { Button } from '@/components/Button/Button';
import WarningSecondaryIcon from '@/images/WarningSecondaryIcon.svg?react';
import { Typography } from '@/components/Typography/Typography';
import { COLORS } from '@/styles/colors';
import { NavigationLink } from '@/components/NavigationLink/NavigationLink';
import { envConfig } from '@/config/envConfig';
import { CONTACT_MOBILE_PHONE, FORMATTED_CONTACT_MOBILE_PHONE } from '@/const/shared';
import { useNavigate } from 'react-router';
import { getMasterAdminBillingPath } from '@/bundle/_MasterAdmin/_BillingPage/path/path';

const PAYMENT_MESSAGE =
  'Your organization has now reached your monthly limit for wires under your current subscription plan. So all Admins of your organization are not able to view wire info for this sending.';
const DEPOSIT_MESSAGE =
  'Your organization has now reached your monthly limit for wires under your current subscription plan. So all Admins of your organization are not able to assign Depositor for this receiving.';

type MasterAdminPaymentsLimitReachedWidgetType = {
  limitType?: 'payment' | 'deposit';
};

export const MasterAdminPaymentsLimitReachedWidget = ({
  limitType = 'payment',
}: MasterAdminPaymentsLimitReachedWidgetType) => {
  const navigate = useNavigate();

  return (
    <DetailsWidget hasHighlight>
      <Box width='100%' display='flex' flexDirection='column' rowGap='20px'>
        <Box width='100%' display='flex' flexDirection='column' alignItems='center' rowGap='24px'>
          <WarningSecondaryIcon />
          <Box display='flex' flexDirection='column' rowGap='8px'>
            <Typography variant='subTitle' color={COLORS.black} fontWeight='medium' textAlign='center'>
              Monthly limit is reached.
            </Typography>
            <Typography variant='bodySmall' color={COLORS.black}>
              {limitType === 'payment' ? PAYMENT_MESSAGE : DEPOSIT_MESSAGE}
            </Typography>
            <Typography variant='bodySmall' color={COLORS.grey[700]}>
              To resume full functionality immediately, you can:
            </Typography>
            <Box as='ul' paddingLeft='26px' margin='0'>
              <li>
                <Typography variant='bodySmall' color={COLORS.black}>
                  Purchase overage wires.
                </Typography>
              </li>
              <li>
                <Typography variant='bodySmall' color={COLORS.grey[700]}>
                  <Typography variant='bodySmall' color={COLORS.black} as='span'>
                    Upgrade your plan
                  </Typography>{' '}
                  to increase your monthly limits. Please contact{' '}
                  <NavigationLink to={`mailto:${envConfig.SUPPORT_EMAIL_URL}`} size='medium'>
                    {envConfig.SUPPORT_EMAIL_URL}{' '}
                  </NavigationLink>{' '}
                  or or call{' '}
                  <NavigationLink to={`tel:${CONTACT_MOBILE_PHONE}`} size='medium'>
                    {FORMATTED_CONTACT_MOBILE_PHONE}{' '}
                  </NavigationLink>
                  for help.
                </Typography>
              </li>
            </Box>
            <Typography variant='bodySmall' color={COLORS.grey[700]}>
              Alternatively, you can wait until your next billing month starts, when your limits will reset
              automatically.
            </Typography>
          </Box>
        </Box>
        <Button onClick={() => navigate(getMasterAdminBillingPath())}>Manage Your Plan</Button>
      </Box>
    </DetailsWidget>
  );
};
